<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
              <b-overlay :show="loader" class="d-inline-block">
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                <b-row>
                                 <b-col lg="4" sm="12">
                                  <ValidationProvider name="Promotion Type" vid="promotion_type" rules="required|min_value:1">
                                      <b-form-group
                                       class="row"
                                       label-cols-sm="12"
                                       label-for="promotion_type_id"
                                       slot-scope="{ valid, errors }"
                                       >
                                       <template v-slot:label>
                                         {{$t('promotionManagement.promotion_type')}} <span class="text-danger">*</span>
                                       </template>
                                       <b-form-select
                                        plain
                                        v-model="user.promotion_type_id"
                                        id="promotion_type_id"
                                        :options="promotionTypesList"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                           <div class="invalid-feedback">
                                               {{ "Promotion Type is Required" }}
                                           </div>
                                        </b-form-group>
                                  </ValidationProvider>
                                  </b-col>
                                  <b-col lg="4" sm="12">
                                  <ValidationProvider name="Promotion Title (En)" vid="promotion_title" rules="required">
                                        <b-form-group
                                         class="row"
                                         label-cols-sm="12"
                                         label-for="promotion_title"
                                         slot-scope="{ valid, errors }"
                                         >
                                         <template v-slot:label>
                                          {{$t('promotionManagement.promotion_title_en')}} <span class="text-danger">*</span>
                                         </template>
                                         <b-form-input
                                          plain
                                          v-model="user.promotion_title"
                                          id="promotion_title"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                           <div class="invalid-feedback">
                                               {{ "Promotion Title (En) is Required" }}
                                           </div>
                                          </b-form-group>
                                  </ValidationProvider>
                                  </b-col>
                                  <b-col lg="4" sm="12">
                                  <ValidationProvider name="Promotion Title (Bn)" vid="promotion_title_bn" rules="required">
                                          <b-form-group
                                           class="row"
                                           label-cols-sm="12"
                                           label-for="promotion_title_bn"
                                            slot-scope="{ valid, errors }"
                                           >
                                          <template v-slot:label>
                                           {{$t('promotionManagement.promotion_title_bn')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-input
                                             plain
                                          v-model="user.promotion_title_bn"
                                          id="promotion_title_bn"
                                         :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                           <div class="invalid-feedback">
                                               {{ "Promotion Title (Bn) is Required" }}
                                           </div>
                                          </b-form-group>
                                          </ValidationProvider>
                                  </b-col>
                                  <b-col lg="4" sm="12">
                                  <ValidationProvider name="Form Date" vid="from_date" rules="required">
                                            <b-form-group
                                             class="row"
                                             label-cols-sm="12"
                                             label-for="from_date"
                                             slot-scope="{ valid, errors }"
                                             >
                                             <template v-slot:label>
                                                 {{$t('promotionManagement.date_from')}} <span class="text-danger">*</span>
                                             </template>
                                             <b-form-input
                                              placeholder="Select Date"
                                              v-model="user.from_date"
                                              id="from_date"
                                               :state="errors[0] ? false : (valid ? true : null)"
                                               ></b-form-input>
                                              <div class="invalid-feedback">
                                               {{ "Date From is Required" }}
                                              </div>
                                          </b-form-group>
                                    </ValidationProvider>
                                    </b-col>
                                    <b-col lg="4" sm="12">
                                    <ValidationProvider name="Date To" vid="date_to" rules="required">
                                       <b-form-group
                                         class="row"
                                         label-cols-sm="12"
                                         label-for="to_date"
                                         slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                          {{$t('promotionManagement.date_to')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                         placeholder="Select Date"
                                         v-model="user.to_date"
                                         id="to_date"
                                         :state="errors[0] ? false : (valid ? true : null)"
                                         ></b-form-input>
                                           <div class="invalid-feedback">
                                               {{ "Date To is Required" }}
                                           </div>
                                          </b-form-group>
                                    </ValidationProvider>
                                    </b-col>
                                    <b-col lg="4" sm="12">
                                    <ValidationProvider name="Promotion Spot (En)" vid="promotion_spot" rules="required">
                                        <b-form-group
                                         class="row"
                                          label-cols-sm="12"
                                          label-for="promotion_spot"
                                           slot-scope="{ valid, errors }"
                                          >
                                          <template v-slot:label>
                                          {{$t('promotionManagement.promotion_spot_en')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-input
                                          plain
                                          v-model="user.promotion_spot"
                                          id="promotion_spot"
                                         :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                           <div class="invalid-feedback">
                                               {{ "Promotion Spot (En) is Required" }}
                                           </div>
                                          </b-form-group>
                                     </ValidationProvider>
                                     </b-col>
                                     <b-col lg="4" sm="12">
                                     <ValidationProvider name="Promotion Spot (Bn)" vid="promotion_spot_bn" rules="required">
                                         <b-form-group
                                         class="row"
                                         label-cols-sm="12"
                                         label-for="promotion_spot_bn"
                                         slot-scope="{ valid, errors }"
                                         >
                                         <template v-slot:label>
                                         {{$t('promotionManagement.promotion_spot_bn')}} <span class="text-danger">*</span>
                                         </template>
                                         <b-form-input
                                         plain
                                          v-model="user.promotion_spot_bn"
                                          id="promotion_spot_bn"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                           <div class="invalid-feedback">
                                               {{ "Promotion Spot (Bn) is Required" }}
                                           </div>
                                          </b-form-group>
                                     </ValidationProvider>
                                     </b-col>
                                     <b-col lg="4" sm="12" v-if="user.promotion_type_id == 2">
                                        <ValidationProvider name="Video URL" vid="url" rules="required">
                                            <b-form-group
                                            class="row"
                                            label-cols-sm="12"
                                            label-for="url"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('promotionManagement.video_url')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                            plain
                                            v-model="user.url"
                                            id="url"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ "Promotion Spot (Bn) is Required" }}
                                            </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                     </b-col>
                                     <b-col lg="4" sm="12" v-if="user.promotion_type_id == 2">
                                        <ValidationProvider name="Duration" vid="duration" rules="required">
                                                <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="duration"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                {{$t('promotionManagement.duration')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                plain
                                                v-model="user.duration"
                                                id="duration"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                    {{ "Duration is Required" }}
                                                </div>
                                                </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="4" sm="12" v-if="user.promotion_type_id != 2">
                                        <ValidationProvider name="attachment" vid="attachment">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="12"
                                                    label-for="attachment"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{ $t('promotionManagement.attachment')}}
                                                    <span v-show="!id" class="text-danger">*</span>
                                                </template>
                                                <b-form-file
                                                id="attachment"
                                                v-on:change="onFileChange"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-file>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="4" sm="12" v-if="user.promotion_type_id != 2">
                                        <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="download"
                                            >
                                            <div>
                                                <br/>
                                                <a :href="productionServiceBaseUrl + 'download-attachment?file=' + user.attachment" title="Attachment Download">Existing Attachment <i class="ri-download-cloud-fill"></i></a>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-row>
                <template #overlay>
                    <div class="text-center w-250">
                        <b-progress :max="100">
                            <b-progress-bar :value="uploadProgress" :label="`${(uploadProgress)}%`"></b-progress-bar>
                            </b-progress>
                        <p id="cancel-label">Please wait...</p>
                    </div>
                </template>
              </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { promotionEntryStoreApi, promotionEntryUpdateApi, promotionEntryFileUploadApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            const tmp = this.getUserInfoData()
            this.current_iamge = tmp.attachment
            // Object.freeze(tmp)
            this.user = tmp
            if (tmp.promotion_type_id === 2) {
                this.user.url = tmp.attachment
            }
        }
    },
     mounted () {
        flatpickr('#from_date', {})
        flatpickr('#to_date', {})
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            productionServiceBaseUrl: productionServiceBaseUrl,
            user: {
                promotion_type_id: 0,
                promotion_title: '',
                promotion_spot: '',
                promotion_spot_bn: '',
                promotion_title_bn: '',
                from_date: '',
                date_to: '',
                url: '',
                attachment: 'null',
                current_iamge: '',
                duration: ''
            },
            fileChunks: [],
            file: null,
            loader: false,
            uploadProgress: 0
        }
    },
    computed: {
        // promotionTypesList: function () {
        //     return this.$store.state.ProductionService.commonObj.promotionTypeList.filter(item => item.status === 1)
        // },
        promotionTypesList: function () {
            const promotionTypesData = this.$store.state.ProductionService.commonObj.promotionTypeList.filter(item => item.status === 1)
            return promotionTypesData.map(item => {
                if (this.$i18n.locale === 'bn') {
                return { value: item.value, text: item.text_bn }
                } else {
                return { value: item.value, text: item.text_en }
                }
            })
        }
    },
    methods: {
        getUserInfoData () {
          const tmpData = this.$store.state.list.find(item => item.id === this.id)
          return JSON.parse(JSON.stringify(tmpData))
        },
        onFileChange (e) {
            this.file = e.target.files[0]
            this.createChunks()
        },
        createChunks () {
            this.fileChunks = []
            const size = 2048 * 250
            const chunks = Math.ceil(this.file.size / size)
            for (let i = 0; i < chunks; i++) {
                this.fileChunks.push(this.file.slice(
                    i * size, Math.min(i * size + size, this.file.size), this.file.type
                ))
            }
        },
        async register () {
            if (this.user.promotion_type_id !== 2) {
                if (!this.validateFile()) {
                    return
                }
            }
            this.$store.commit('mutateCommonProperties', { loading: true })
            this.loader = true
            const totalChunks = this.fileChunks.length - 1
            const steps = 100 / (totalChunks + 2)
            let fileUploadResult = { success: false, path: '' }
            for (let i = 0; i <= totalChunks; i++) {
                const headerConfig = {
                    headers: { 'content-type': 'application/octat-stream' }
                }
                var formDatas = new FormData()
                formDatas.set('is_last', i === totalChunks)
                formDatas.set('file', this.fileChunks[i], `${this.file.name}.part`)
                fileUploadResult = await RestApi.postData(productionServiceBaseUrl, promotionEntryFileUploadApi, formDatas, headerConfig)
                this.uploadProgress += steps
                if (!fileUploadResult.success) {
                    this.loader = false
                    this.$refs.form.setErrors({ attachment: fileUploadResult.errors.file })
                    window.vm.$toast.error({
                        title: 'Error',
                        message: 'Operation failed! Please, try again.'
                    })
                    return
                }
            }
            if (this.user.promotion_type_id !== 2) {
                if (fileUploadResult.success) {
                    this.user.attachment = fileUploadResult.path
                }
            }
            let result = null
            const loadingState = { loading: false, listReload: true }
            this.uploadProgress += steps - 5
            if (this.id) {
                result = await RestApi.putData(productionServiceBaseUrl, `${promotionEntryUpdateApi}/${this.id}`, this.user)
            } else {
                this.user = Object.assign({}, this.user, { created_by: 1 })
                result = await RestApi.postData(productionServiceBaseUrl, promotionEntryStoreApi, this.user)
            }
            this.$store.dispatch('mutateCommonProperties', loadingState)
            if (result.success) {
                this.uploadProgress += 5
                this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save'),
                color: '#D6E09B'
            })
                this.$bvModal.hide('modal-4')
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        },
        validateFile () {
            /** if form in edit mode and file is not selected */
            if (this.fileChunks.length === 0 && this.user.id) {
                return true
            }
            if (this.fileChunks.length === 0) {
               this.$refs.form.setErrors({ attachment: ['Attachment Field is Required.'] })
               return false
            }
            if (this.file.size > 100000000) {
                this.$refs.form.setErrors({ attachment: ['Too large file. Allowed max size is 100 MB'] })
                return
            }
            /** File extension validation */
            let fileExtension = this.file.name.split('.').pop()
            fileExtension = fileExtension.toLowerCase()
            const allowedFileExtensions = ['jpg', 'jpeg', 'png', 'tiff', 'pdf', 'doc', 'docx', '3gp', 'amr', 'awb', 'mp3', 'ogg', 'wav', 'webm', 'mp4', 'mov', 'wmv', 'avi', 'flv', 'mkv']
            if (allowedFileExtensions.indexOf(fileExtension) === -1) {
               this.$refs.form.setErrors({ attachment: ['File extension is not allowed'] })
               return false
            }
            return true
        }
    }
}
</script>
<style scoped>
[dir=ltr][mode=light] .progress {
    background-color: rgb(45, 45, 46);
}
.w-250 {
    width: 250px;
}
</style>
